export function HelpShortcutsIntroContent() {
  return (
    <div class="help-copy">
      <p>
        החזק את <kbd class="shortcut-key help-inline-key">Alt</kbd> לרגע כדי לחשוף רמזי קיצורים מעל יעדי האפליקציה הראשיים.
      </p>
      <p>
        לאחר מכן אפשר ללחוץ ישירות על המקש שמוצג, או לשחרר את <kbd class="shortcut-key help-inline-key">Alt</kbd> ולהמשיך לעבוד כרגיל.
      </p>
    </div>
  );
}
